<template>
  <kye-dialog
    :width="dialogWidth"
    :visible.sync="value"
    :append-to-body="appendToBody"
    @close="onClose"
    @open="open">
    <template slot="title">
      <slot name="title">
        <div class="kye-multiple-dept-dialog-title">
          <span class="kye-multiple-dept-dialog-title-text">选择组织</span>
          <span class="kye-multiple-dept-dialog-title-desc">{{bakMonthLabel}}</span>
        </div>
      </slot>
    </template>
    <tree-body
      ref="treeBody"
      :load="load"
      :hasAllTree="hasAllTree"
      :auth="auth"
      :init="init"
      :historyId="historyId"
      :accordion="accordion"
      :checkStrictly="checkStrictly"
      :setCurrentNode="setCurrentNode"
      :searchUrl="searchUrl"
      :searchParams="searchParams"
      :deptSearchResultUrl="deptSearchResultUrl"
      :formatResult="formatResult"
      :showPanel="showPanel"
      :fetchData="fetchData"
      :defaultCheckedKeys="defaultCheckedKeys"
      :defaultExpandedKeys="defaultExpandedKeys"
      :searchCheckedNode="searchCheckedNode"
      @chooseDepartment="chooseDepartment"
      @current-node-change="currentNodeChange"
      @deleteAllCheckedNode="deleteAllCheckedNode"
      @deleteCheckedNode="deleteCheckedNode"
      @getCheckedNodeList="getCheckedNodeList"
    >
      <template slot="treeLabel" slot-scope="{node,data,checkedMapDept}">
        <slot name="treeLabel" :node='node' :data='data' :checkedMapDept="checkedMapDept">{{node.label}}</slot>
      </template>
      <template v-if="$scopedSlots.panel" slot="panel" slot-scope="slotProps">
        <slot name="panel" v-bind="slotProps"></slot>
      </template>
    </tree-body>
    <template slot="footer">
      <el-checkbox v-if="containLeaf" v-model="isChecked" style="float:left;">是否包含子节点</el-checkbox>
      <slot name="footerLeft"></slot>
      <el-button type="primary" hotkey="ctrl+s" :disabled="disabledToSave" @click="saveSelectedDept">保存(S)</el-button>
      <el-button @click="$emit('input', false)">取消</el-button>
    </template>
  </kye-dialog>
</template>

<script>
  import {
    fetchGenericTreeData,
    runFetchAxios,
    hasAllTreeAuth,
    encodeKey,
  } from '../query-table/utils'
  import treeBody from './components/tree-body.vue'
  export default {
    name: 'KyeDeptMultiple',
    components: { treeBody },
    props: {
      model: Object,
      containLeaf: { // 显示隐藏 ”是否包含子节点”
        type: Boolean,
        default: true
      },
      disabledCache: { // 是否禁用缓存，如果为false，每次打开弹框时都调用接口
        type: Boolean,
        default: true
      },
      value: { // 显示弹窗的变量
        type: Boolean,
        default: false
      },
      auth: { // 是否有权限
        type: Boolean,
        default: false
      },
      hasAllTreeAuth: { // 模糊搜索是否不走权限接口的数据，不替换原有树，仅做查找
        type: Boolean,
        default: false
      },
      accordion: { // 是否每次只打开一个同级树节点展开
        type: Boolean,
        default: true
      },
      fetchData: { // 外部提供的方法去获取组织树
        type: Function
      },
      filterData: { // 过滤组织树的方法
        type: Function
      },
      setCurrentNode: { // 复选框change之前的回调，返回true,则允许执行之后的内部逻辑，反之阻止
        type: Function
      },
      searchUrl: { // 搜索接口url
        type: String,
      },
      searchParams: { // 搜索接口url参数
        type: Function,
      },
      deptSearchResultUrl: { // 搜索结果接口url
        type: String,
      },
      formatResult: { // 过滤搜索结果的方法。
        type: Function
      },
      formatData: { // 格式化数据，点击保存时调用
        type: Function
      },
      showPanel: { // 是否开启右侧的已选择面板
        type: Boolean,
        default: false
      },
      checkStrictly: { // 是否不联动，true则不联动，反之
        type: Boolean,
        default: false
      },
      preloadDeptTree: { // 是否预加载
        type: Boolean,
        default: true
      },
      defaultCheckedKeys: { // 默认勾选的节点ID
        type: Array,
        default: () => ([])
      },
      defaultExpandedKeys: { // 默认展开的节点ID
        type: Array,
        default: () => ([])
      },
      fetchAxios: { // 获取历史月份组织参数 { data: {bakMonth: '2020-01'}, ...其他属性为 http 方法第三个参数为对象时的属性，比如{cancel,log,axios} }
        type: Function,
      },
      disabledToSave: { // 是否禁用保存按钮
        type: Boolean,
        default: false
      },
      searchCheckedNode: { // 模糊搜索匹配后是否直接选中
        type: Boolean,
        default: false
      },
      appendToBody: { // Dialog 弹窗是否挂载至根节点
        type: Boolean,
        default: false
      },
      historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
    },
    // watch: {
    //   value(val) {
    //     if (val) {
    //       this.$nextTick(() => {
    //         this.$refs.treeBody && this.$refs.treeBody.$refs.inputSearch && this.$refs.treeBody.$refs.inputSearch.$refs.searchTips && this.$refs.treeBody.$refs.inputSearch.$refs.searchTips.focus()
    //       })
    //     }
    //   }
    // },
    data () {
      return {
        load: false,
        hasAllTree: false,
        init: false, // true 表示初始化无数据
        bakMonth: '',
        isChecked: true,
      }
    },
    mounted () {
      this.preloadDeptTree && this.$bus.$emit('preload-dept-tree')
    },
    computed: {
      bakMonthLabel () {
        return this.bakMonth ? `历史数据：${this.bakMonth}` : '实时数据'
      },
      // 弹窗的宽度
      dialogWidth() {
        const width = this.showPanel ? '994px' : '400px'
        return width
      },
      checkedNodeList() {
        return this.$refs.treeBody && this.$refs.treeBody.checkedNodeList
      },
      orgTreeDeptMap() {
        return (this.$refs.treeBody && this.$refs.treeBody.orgTreeDeptMap) || {}
      }
    },
    methods: {
      onClose () {
        this.$refs.treeBody.$refs.inputSearch.clearDepartment()
        this.$emit('input', false)
      },
      async open () {
        const attrs = {fetchAxios: this.fetchAxios}
        this.bakMonthCache = this.bakMonthCache || {}
        let bakMonthConf = runFetchAxios(attrs)
        let cacheKey = ''
        let hasBakMonth = false
        if (bakMonthConf) {
          cacheKey = encodeKey(JSON.stringify(bakMonthConf.data))
          hasBakMonth = this.disabledCache && this.bakMonthCache[cacheKey]
          this.bakMonth = bakMonthConf.data.month || bakMonthConf.data.bakMonth
        } else {
          this.bakMonth = ''
        }
        const authTree = (this.$refs.treeBody && this.$refs.treeBody.authTree) || []
        // authTree为空、缓存的历史数据不存在、不需要缓存
        let needReq = !authTree.length || (bakMonthConf && !hasBakMonth) || !this.disabledCache
        if (needReq) {
          this.load = true
          this.hasAllTree = hasAllTreeAuth() || this.hasAllTreeAuth
          const auth = this.auth
          const fetchData = this.fetchData
          const promise = fetchData ? fetchData() : fetchGenericTreeData(auth, attrs)
          promise.then(res => {
            if (!res || !res.id || !res.parentId || !res.children) {
              this.init = true
              this.load = false
              return
            }
            // 缓存历史数据
            if (this.bakMonth && this.disabledCache) {
              this.bakMonthCache[cacheKey] = res
            }
            // 过滤节点
            const filterData = this.filterData
            if (filterData && typeof filterData === 'function') {
              let filterRes = filterData(res)
              if (filterRes.then) {
                filterRes.then(_ => {
                  this.openInitMethods(_)
                })
              } else {
                res = filterRes
                this.openInitMethods(res)
              }
            } else {
              this.openInitMethods(res)
            }
          }).catch(e => {
            this.load = false
            throw e
          })
        } else {
          this.setCheckedKeys()
        }
      },
      async openInitMethods (res) {
        const auth = this.auth
        const fetchData = this.fetchData
        this.initData(res, this.hasAllTree && !fetchData && !auth && !this.bakMonth)
        this.init = false
        this.load = false
        this.setCheckedKeys()
      },
      saveSelectedDept () {
        const deptMap = this.orgTreeDeptMap
        let nodes = this.checkedNodeList.map(id => deptMap[id])
        const authTree = (this.$refs.treeBody && this.$refs.treeBody.authTree) || []
        let data = {
          deptMap,
          tree: authTree,
          value: [],
          nodes,
        }
        if (this.containLeaf) {
          data['leaf'] = this.isChecked
        }
        if (nodes && nodes.length) {
          let value = nodes.map(v => v.id)
          let label = nodes.map(v => v.name).join('，')
          // 选中节点详情
          let idsInfo = value || []
          idsInfo = idsInfo.reduce((prev, id) => {
            const curInfo = deptMap[id]
            if (!curInfo) {
              return prev
            }
            const obj = {
              id: id,
              name: curInfo.name,
              departmentIdRoute: curInfo.departmentIdRoute,
              departmentRoute: curInfo.departmentRoute,
              level: curInfo.level
            }
            prev.push(obj)
            return prev
          }, [])
          data.idsInfo = idsInfo
          // 格式化数据
          if (this.formatData && typeof this.formatData === 'function') {
            value = this.formatData({ value, map: deptMap, tree: authTree })
          }
          data.value = value
          data.label = label

          this.$emit('change', data)
          this.$emit('input', false)
        } else {
          this.$message.warning('请先选择')
        }
      },
      initData (data, all) {
        this.$refs.treeBody.initData(data, all)
      },
      setCheckedKeys (data) {
        this.$nextTick(_ => {
          this.$refs.treeBody.setCheckedKeys(data)
        })
      },
      getCheckedNodes () {
        return this.$refs.treeBody.getCheckedNodes()
      },
      currentNodeChange (data) {
        this.$emit('current-node-change', data)
      },
      chooseDepartment () {
        this.init = false
      },
      deleteAllCheckedNode () {
        this.$emit('deleteAllCheckedNode')
      },
      deleteCheckedNode (id, data) {
        this.$emit('deleteCheckedNode', id, data)
      },
      getCheckedNodeList (data) {
        this.$emit('getCheckedNodeList', data)
      }
    }
  }
</script>

<style lang="less">
.kye-multiple-dept-dialog-title {
  &-text {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 16px;
  }
  &-desc {
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    color: #999999;
    position: absolute;
    right: 68px;
    top: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept-multiple/kye-dept-multiple.vue